export const AllBlocks = [
	{
	  id: "image",
	  label: "Image",
	  category: '🖼️ Media',
	  media: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-500">
   <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M0.833333 0H14.1667C14.6269 0 15 0.3731 15 0.833333V14.1667C15 14.6269 14.6269 15 14.1667 15H0.833333C0.3731 15 0 14.6269 0 14.1667V0.833333C0 0.3731 0.3731 0 0.833333 0ZM1.66667 6.75042L3.33333 5.08375L7.91667 9.66708L10.8333 6.75042L13.3333 9.25042V1.66667H1.66667V6.75042ZM1.66667 9.10742V13.3333H4.25042L6.73817 10.8456L3.33333 7.44075L1.66667 9.10742ZM13.3333 13.3333H6.60742L10.8333 9.10742L13.3333 11.6074V13.3333ZM9.16667 4.58333C9.16667 5.27369 9.72633 5.83333 10.4167 5.83333C11.107 5.83333 11.6667 5.27369 11.6667 4.58333C11.6667 3.89297 11.107 3.33333 10.4167 3.33333C9.72633 3.33333 9.16667 3.89297 9.16667 4.58333Z" />
   </svg>
   `,
	  content: {
	    type: "image",
	    style: {
		 width: "auto",
		 height: "auto",
	    },
	    attributes: { alt: "Image" },
	  },
	},
	{
	  id: "video",
	  label: "Video",
	  category: '🖼️ Media',
	  media: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-500">
   <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.827833C0 0.370633 0.370792 0 0.827833 0H14.1722C14.6293 0 15 0.370792 15 0.827833V14.1722C15 14.6293 14.6293 15 14.1722 15H0.827833C0.370633 15 0 14.6293 0 14.1722V0.827833ZM1.66667 1.66667V13.3333H13.3333V1.66667H1.66667ZM10.4173 7.22267L6.35158 4.51216C6.29683 4.47565 6.2325 4.45617 6.16667 4.45617C5.98258 4.45617 5.83333 4.60541 5.83333 4.78951V10.2105C5.83333 10.2763 5.85283 10.3407 5.88933 10.3954C5.99142 10.5486 6.19842 10.59 6.35158 10.4878L10.4173 7.77733C10.4539 7.75292 10.4853 7.7215 10.5098 7.68492C10.6119 7.53175 10.5705 7.32475 10.4173 7.22267Z" fill="currentColor"/>
   </svg>`,
	  content: {
	    type: "video",
	    style: {
		 width: "auto", // Default width, can be adjusted in the editor
		 height: "auto", // Height set to auto to maintain aspect ratio
	    },
	  },
	},
	{
		id: 'uikit-accordion',
		label: 'Accordion',
		category: '🧩 UI Components',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill="#ecf0f1"><path d="M50.16667,78.83333h107.5v14.33333h-107.5zM50.16667,35.83333h107.5v14.33333h-107.5zM50.16667,121.83333h107.5v14.33333h-107.5zM21.5,75.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM21.5,118.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM21.5,32.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75z"></path></g></g></svg>
		`,
		content: `
			<ul uk-accordion>
			    <li class="uk-open">
			        <a class="uk-accordion-title" href="#">Item 1</a>
			        <div class="uk-accordion-content">
			            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
			        </div>
			    </li>
			    <li>
			        <a class="uk-accordion-title" href="#">Item 2</a>
			        <div class="uk-accordion-content">
			            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor reprehenderit.</p>
			        </div>
			    </li>
			    <li>
			        <a class="uk-accordion-title" href="#">Item 3</a>
			        <div class="uk-accordion-content">
			            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat proident.</p>
			        </div>
			    </li>
			</ul>
		`
	},
	{
		id: 'uikit-button',
		label: 'Button',
		category: '🧩 UI Components',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="none" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ECF0F1"><path d="M14.33333,50.16667c-7.83362,0 -14.33333,6.49972 -14.33333,14.33333v43c0,7.83362 6.49972,14.33333 14.33333,14.33333h143.33333c7.83362,0 14.33333,-6.49972 14.33333,-14.33333v-43c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333zM14.33333,64.5h143.33333v43h-143.33333zM50.16667,78.83333v14.33333h14.33333v-14.33333zM78.83333,78.83333v14.33333h14.33333v-14.33333zM107.5,78.83333v14.33333h14.33333v-14.33333z"></path></g></g></svg>
		`,
		content: `<button class="inline-block px-6 py-2 border border-gray-400 rounded bg-white text-gray-800 hover:bg-gray-50 transition-colors cursor-pointer">Default</button>`
	},
	{
		id: 'uikit-card',
		label: 'Card',
		category: '🧩 UI Components',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="none" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M24.08,30.96c-9.46,0 -17.2,7.74 -17.2,17.2v75.68c0,9.46 7.74,17.2 17.2,17.2h123.84c9.46,0 17.2,-7.74 17.2,-17.2v-75.68c0,-9.46 -7.74,-17.2 -17.2,-17.2zM24.08,37.84h123.84c5.73781,0 10.32,4.58219 10.32,10.32v6.88h-144.48v-6.88c0,-5.73781 4.58219,-10.32 10.32,-10.32zM13.76,72.24h144.48v51.6c0,5.73781 -4.58219,10.32 -10.32,10.32h-123.84c-5.73781,0 -10.32,-4.58219 -10.32,-10.32zM30.96,82.56v6.88h55.04v-6.88z"></path></g></g></svg>
		`,
		content: `
			
<div class="flex p-2 bg-white">
<div class="w-full m-2 max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    <a href="#">
        <img class="p-8 rounded-t-lg" src="https://media.istockphoto.com/id/856794670/photo/beautiful-luxury-home-exterior-with-green-grass-and-landscaped-yard.jpg?s=612x612&w=0&k=20&c=Jaun3vYekdy6aBcqq5uDQp_neNp5jmdLZXZAqqhcjk8=" alt="product image" />
    </a>
    <div class="px-5 pb-5">
        <a href="#">
            <h5 class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white"> 3-Bedroom Modern House in London</h5>
        </a>
        <div class="flex items-center mt-2.5 mb-5">
            <div class="flex items-center space-x-1 rtl:space-x-reverse">
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
            </div>
            <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-sm dark:bg-blue-200 dark:text-blue-800 ms-3">5.0</span>
        </div>
        <div class="flex items-center justify-between">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">$599</span>
            <a href="#" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Add to cart</a>
        </div>
    </div>
</div>


<div class="w-full m-2 max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    <a href="#">
        <img class="p-8 rounded-t-lg" src="https://hips.hearstapps.com/hmg-prod/images/hbx110119wholehome-019-copy-1569949392.jpg" alt="product image" />
    </a>
    <div class="px-5 pb-5">
        <a href="#">
            <h5 class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white"> 3-Bedroom Modern House in London</h5>
        </a>
        <div class="flex items-center mt-2.5 mb-5">
            <div class="flex items-center space-x-1 rtl:space-x-reverse">
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
            </div>
            <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-sm dark:bg-blue-200 dark:text-blue-800 ms-3">5.0</span>
        </div>
        <div class="flex items-center justify-between">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">$599</span>
            <a href="#" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Add to cart</a>
        </div>
    </div>
</div>

<div class="w-full m-2 max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    <a href="#">
        <img class="p-8 rounded-t-lg" src="https://media.gettyimages.com/id/183881669/photo/house.jpg?s=612x612&w=gi&k=20&c=vKx9LMH3qNa5n2dLSba8LPjZaSVNwuRDD7B1wisItYU=" alt="product image" />
    </a>
    <div class="px-5 pb-5">
        <a href="#">
            <h5 class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white"> 3-Bedroom Modern House in London</h5>
        </a>
        <div class="flex items-center mt-2.5 mb-5">
            <div class="flex items-center space-x-1 rtl:space-x-reverse">
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
                <svg class="w-4 h-4 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                </svg>
            </div>
            <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-sm dark:bg-blue-200 dark:text-blue-800 ms-3">5.0</span>
        </div>
        <div class="flex items-center justify-between">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">$599</span>
            <a href="#" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Add to cart</a>
        </div>
    </div>
</div>

</div>
		`
	},
	{
		id: 'uikit-column',
		label: 'Column 1-2',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="none" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ECF0F1"><path d="M43,14.33333c-7.83362,0 -14.33333,6.49972 -14.33333,14.33333v114.66667c0,7.83362 6.49972,14.33333 14.33333,14.33333h28.66667c7.83362,0 14.33333,-6.49972 14.33333,-14.33333v-114.66667c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333zM100.33333,14.33333v14.33333h28.66667v28.66667h-28.66667v14.33333h28.66667v28.66667h-28.66667v14.33333h28.66667v28.66667h-28.66667v14.33333h28.66667c7.83362,0 14.33333,-6.49972 14.33333,-14.33333v-114.66667c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333zM43,28.66667h28.66667v28.66667h-28.66667zM43,71.66667h28.66667v28.66667h-28.66667zM43,114.66667h28.66667v28.66667h-28.66667z"></path></g></g></svg>
		`,
		content: `
			<div class="columns-2 gap-6">
			    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>

			    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

			    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
			</div>
		`
	},
	{
		id: 'uikit-container',
		label: 'Container',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ECF0F1"><path d="M48.375,21.5c-14.78109,0 -26.875,12.09391 -26.875,26.875v75.25c0,14.78109 12.09391,26.875 26.875,26.875h75.25c14.78109,0 26.875,-12.09391 26.875,-26.875v-75.25c0,-14.78109 -12.09391,-26.875 -26.875,-26.875zM48.375,32.25h75.25c8.97641,0 16.125,7.14859 16.125,16.125v75.25c0,8.97641 -7.14859,16.125 -16.125,16.125h-75.25c-8.97641,0 -16.125,-7.14859 -16.125,-16.125v-75.25c0,-8.97641 7.14859,-16.125 16.125,-16.125zM69.875,53.75c-8.84221,0 -16.125,7.28279 -16.125,16.125v32.25c0,8.84221 7.28279,16.125 16.125,16.125h32.25c8.84221,0 16.125,-7.28279 16.125,-16.125v-32.25c0,-8.84221 -7.28279,-16.125 -16.125,-16.125zM69.875,64.5h32.25c3.02579,0 5.375,2.34921 5.375,5.375v32.25c0,3.02579 -2.34921,5.375 -5.375,5.375h-32.25c-3.02579,0 -5.375,-2.34921 -5.375,-5.375v-32.25c0,-3.02579 2.34921,-5.375 5.375,-5.375z"></path></g></g></svg>
		`,
		content: `
			<section class="bg-cover bg-center h-[500px] flex items-center justify-center text-white" style="background-image: url('https://static.vecteezy.com/system/resources/thumbnails/036/725/193/small_2x/ai-generated-real-estate-advertisment-background-with-copy-space-free-photo.jpg');">
    <div class="bg-black bg-opacity-50 p-10 rounded-lg">
      <h1 class="text-4xl md:text-5xl font-bold mb-4">Find Your Dream Home</h1>
      <p class="text-lg mb-6">Browse thousands of listings in top locations.</p>
      <a href="#listings" class="bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200">Explore Properties</a>
    </div>
  </section>
		`
	},
	{
		id: 'uikit-grid',
		label: 'Grid',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M16.125,32.25v107.5h139.75v-107.5zM26.875,43h21.5v21.5h-21.5zM59.125,43h21.5v21.5h-21.5zM91.375,43h21.5v21.5h-21.5zM123.625,43h21.5v21.5h-21.5zM26.875,75.25h21.5v21.5h-21.5zM59.125,75.25h21.5v21.5h-21.5zM91.375,75.25h21.5v21.5h-21.5zM123.625,75.25h21.5v21.5h-21.5zM26.875,107.5h21.5v21.5h-21.5zM59.125,107.5h21.5v21.5h-21.5zM91.375,107.5h21.5v21.5h-21.5zM123.625,107.5h21.5v21.5h-21.5z"></path></g></g></svg>
		`,
		content: `
			<section class="bg-blue-600 py-12 mt-12">
    <div class="max-w-4xl mx-auto text-center text-white px-4">
      <h2 class="text-3xl font-bold mb-4">Ready to find your next home?</h2>
      <p class="mb-6">Sign up now to get personalized property alerts and exclusive listings.</p>
      <a href="#" class="bg-white text-blue-600 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100">Get Started</a>
    </div>
  </section>
		`
	},
	{
		id: 'uikit-heading',
		label: 'Heading',
		category: '🧩 UI Components',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M78.83333,28.66667v43h-43v-43h-21.5v114.66667h21.5v-50.16667h43v50.16667h21.5v-114.66667zM155.20133,28.66667l-40.53467,15.1575v18.8125l21.5,-6.84417v87.54083h21.5v-114.66667z"></path></g></g></svg>
		`,
		content: `
			<h1 class="text-4xl font-light tracking-tight text-gray-900">Small</h1>
		`
	},
	{
		id: 'uikit-link',
		label: 'Link',
		category: '🧩 UI Components',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M50.16667,78.83333h71.66667v14.33333h-71.66667z"></path><path d="M129,50.16667c-5.10267,0 -23.564,0 -28.66667,0v14.33333c5.53267,0 23.134,0 28.66667,0c11.87517,0 21.5,9.62483 21.5,21.5c0,11.87517 -9.62483,21.5 -21.5,21.5c-5.53267,0 -23.134,0 -28.66667,0v14.33333c5.10267,0 23.564,0 28.66667,0c19.78717,0 35.83333,-16.04617 35.83333,-35.83333c0,-19.78717 -16.04617,-35.83333 -35.83333,-35.83333zM43,121.83333c5.10267,0 23.564,0 28.66667,0v-14.33333c-5.53267,0 -23.134,0 -28.66667,0c-11.87517,0 -21.5,-9.62483 -21.5,-21.5c0,-11.87517 9.62483,-21.5 21.5,-21.5c5.53267,0 23.134,0 28.66667,0v-14.33333c-5.10267,0 -23.564,0 -28.66667,0c-19.78717,0 -35.83333,16.04617 -35.83333,35.83333c0,19.78717 16.04617,35.83333 35.83333,35.83333z"></path></g></g></svg>
		`,
		content: `
			<a class="font-semibold text-gray-800 hover:text-gray-600 no-underline" href="#">Heading</a>
		`
	},
	{
		id: 'uikit-nav',
		label: 'Nav',
		category: '🧭Navigation',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M21.5,35.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h129c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,78.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h129c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,121.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h129c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376z"></path></g></g></svg>
		`,
		content: `
			<nav class="uk-navbar-container" uk-navbar>
			    <div class="uk-navbar-left">

			        <ul class="uk-navbar-nav">
			            <li class="uk-active"><a href="#">Active</a></li>
			            <li>
			                <a href="#">Parent</a>
			                <div class="uk-navbar-dropdown">
			                    <ul class="uk-nav uk-navbar-dropdown-nav">
			                        <li class="uk-active"><a href="#">Active</a></li>
			                        <li><a href="#">Item</a></li>
			                        <li class="uk-nav-header">Header</li>
			                        <li><a href="#">Item</a></li>
			                        <li><a href="#">Item</a></li>
			                        <li class="uk-nav-divider"></li>
			                        <li><a href="#">Item</a></li>
			                    </ul>
			                </div>
			            </li>
			            <li><a href="#">Item</a></li>
			        </ul>

			    </div>
			    <div class="uk-navbar-right">

			        <ul class="uk-navbar-nav">
			            <li>
			                <a href="#">Parent</a>
			                <div class="uk-navbar-dropdown">
			                    <ul class="uk-nav uk-navbar-dropdown-nav">
			                        <li class="uk-active"><a href="#">Active</a></li>
			                        <li><a href="#">Item</a></li>
			                        <li class="uk-nav-header">Header</li>
			                        <li><a href="#">Item</a></li>
			                        <li><a href="#">Item</a></li>
			                        <li class="uk-nav-divider"></li>
			                        <li><a href="#">Item</a></li>
			                    </ul>
			                </div>
			            </li>
			        </ul>
			    </div>
			</nav>
		`
	},
	{
		id: 'uikit-section',
		label: 'Section',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M77.9375,26.875c-13.29053,0 -24.1875,10.89697 -24.1875,24.1875c0,7.24365 3.29639,13.68945 8.39844,18.14063c-5.01807,3.94727 -8.39844,9.97315 -8.39844,16.79688c0,11.8208 9.6792,21.5 21.5,21.5h18.8125c7.47461,0 13.4375,5.96289 13.4375,13.4375c0,7.47461 -5.96289,13.4375 -13.4375,13.4375h-16.125c-7.47461,0 -13.4375,-5.96289 -13.4375,-13.4375v-2.6875h-10.75v2.6875c0,13.29053 10.89697,24.1875 24.1875,24.1875h16.125c13.29053,0 24.1875,-10.89697 24.1875,-24.1875c0,-7.24365 -3.29639,-13.68945 -8.39844,-18.14062c5.01807,-3.94727 8.39844,-9.97315 8.39844,-16.79687c0,-11.8208 -9.6792,-21.5 -21.5,-21.5h-18.8125c-7.47461,0 -13.4375,-5.96289 -13.4375,-13.4375c0,-7.47461 5.96289,-13.4375 13.4375,-13.4375h16.125c7.47461,0 13.4375,5.96289 13.4375,13.4375v2.6875h10.75v-2.6875c0,-13.29053 -10.89697,-24.1875 -24.1875,-24.1875zM75.25,74.91406c0.90283,0.10498 1.76367,0.33594 2.6875,0.33594h18.8125c6.00489,0 10.75,4.74512 10.75,10.75c0,6.00489 -4.74511,10.75 -10.75,10.75v0.33594c-0.90283,-0.10498 -1.76367,-0.33594 -2.6875,-0.33594h-18.8125c-6.00488,0 -10.75,-4.74511 -10.75,-10.75c0,-6.00488 4.74512,-10.75 10.75,-10.75z"></path></g></g></svg>
		`,
		content: `
			<section class="py-16 bg-white">
			    <div class="max-w-5xl mx-auto px-4">
			        <h3 class="text-2xl font-semibold mb-6">Section Default</h3>
			        <div class="grid grid-cols-3 gap-6">
			            <div>
			                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
			            </div>
			            <div>
			                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
			            </div>
			            <div>
			                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
			            </div>
			        </div>
			    </div>
			</section>
		`
	},
	{
		id: 'uikit-tile',
		label: 'Tile',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M17.2,34.4c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v34.4c0,3.1648 2.56853,5.73333 5.73333,5.73333h34.4c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-34.4c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333zM80.26667,40.13333c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h74.53333c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843zM34.4,45.86667c6.33533,0 11.46667,5.13133 11.46667,11.46667c0,6.3296 -5.13133,11.46667 -11.46667,11.46667c-6.33533,0 -11.46667,-5.13707 -11.46667,-11.46667c0,-6.33533 5.13133,-11.46667 11.46667,-11.46667zM80.26667,63.06667c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h51.6c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843zM17.2,97.46667c-3.1648,0 -5.73333,2.56853 -5.73333,5.73333v34.4c0,3.1648 2.56853,5.73333 5.73333,5.73333h34.4c3.1648,0 5.73333,-2.56853 5.73333,-5.73333v-34.4c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333zM80.26667,103.2c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h74.53333c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843zM22.93333,108.93333h22.93333v22.93333h-22.93333zM80.26667,126.13333c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h51.6c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843z"></path></g></g></svg>
		`,
		content: `
			<div class="grid grid-cols-2 text-center">
			    <div>
			        <div class="p-8 bg-white">
			            <p class="text-lg font-semibold">Default</p>
			        </div>
			    </div>
			    <div>
			        <div class="p-8 bg-gray-100">
			            <p class="text-lg font-semibold">Muted</p>
			        </div>
			    </div>
			    <div>
			        <div class="p-8 bg-blue-600 text-white">
			            <p class="text-lg font-semibold">Primary</p>
			        </div>
			    </div>
			    <div>
			        <div class="p-8 bg-gray-800 text-white">
			            <p class="text-lg font-semibold">Secondary</p>
			        </div>
			    </div>
			</div>
		`
	},
	{
		id: 'uikit-width',
		label: 'Width',
		category: '📏 Layout',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="48" height="48"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="black" fill-rule="nonzero" stroke="black" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M9.9975,48.0525c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v68.8c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-68.8c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM161.3575,48.0525c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v68.8c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-68.8c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM24.08,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM37.84,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM51.6,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM65.36,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM79.12,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM92.88,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM106.64,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM120.4,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM134.16,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM147.92,48.16c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM38.8075,68.6925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-0.55094,0.09406 -1.06156,0.30906 -1.505,0.645l-18.275,13.76c-0.90031,0.645 -1.43781,1.69313 -1.43781,2.795c0,1.10188 0.5375,2.15 1.43781,2.795l18.275,13.76c1.54531,1.15563 3.73563,0.84656 4.89125,-0.69875c1.15563,-1.54531 0.84656,-3.73562 -0.69875,-4.89125l-9.9975,-7.525h109.865l-9.9975,7.525c-1.54531,1.15563 -1.85437,3.34594 -0.69875,4.89125c1.15563,1.54531 3.34594,1.85438 4.89125,0.69875l18.275,-13.76c0.90031,-0.645 1.43781,-1.69312 1.43781,-2.795c0,-1.10187 -0.5375,-2.15 -1.43781,-2.795l-18.275,-13.76c-0.76594,-0.57781 -1.74687,-0.81969 -2.6875,-0.645c-1.41094,0.18813 -2.55312,1.22281 -2.88906,2.60688c-0.33594,1.37062 0.215,2.82187 1.38406,3.62812l9.9975,7.525h-109.865l9.9975,-7.525c1.38406,-0.84656 1.98875,-2.55312 1.43781,-4.085c-0.5375,-1.53187 -2.08281,-2.4725 -3.69531,-2.2575zM24.08,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM37.84,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM51.6,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM65.36,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM79.12,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM92.88,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM106.64,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM120.4,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM134.16,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM147.92,116.96c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44z"></path></g></g></svg>
		`,
		content: `
			<div class="flex gap-2 text-center">
			    <div class="flex-1">
			        <div class="bg-white border border-gray-200 rounded shadow-sm p-4">Expand</div>
			    </div>
			    <div class="w-1/3">
			        <div class="bg-white border border-gray-200 rounded shadow-sm p-4">1/3</div>
			    </div>
			    <div class="flex-1">
			        <div class="bg-white border border-gray-200 rounded shadow-sm p-4">Expand</div>
			    </div>
			    <div class="flex-1">
			        <div class="bg-white border border-gray-200 rounded shadow-sm p-4">Expand</div>
			    </div>
			</div>
		`
	},
	{
		id: 'google-translate',
		label: 'Google Translate',
		category: '⚙️ Integrations',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
				<path d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 0 1 6.412 9m6.088 9h7M11 18l1.9-5.7a1.11 1.11 0 0 1 2.1 0L17 18m-1.5-3h-2"/>
			</svg>
		`,
		content: {
			type: 'google-translate',
			tagName: 'div',
			attributes: {
				id: 'google_translate_element',
				class: 'google-translate-widget'
			},
			style: {
				margin: '10px 0',
				padding: '10px',
				'border-radius': '4px',
				'background-color': '#f8f9fa',
				border: '1px solid #e9ecef'
			}
		}
	},
	{
		id: 'linkpreview-navbar',
		label: 'Navbar',
		category: '🧭Navigation',
		media: `
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="text-gray-500"><path d="M20.9991 19.0822V4.91781C20.9991 3.85863 20.1404 3 19.0813 3H4.91781C3.85863 3 3 3.85863 3 4.91781V19.0822C3 20.1414 3.85863 21 4.91781 21H19.0813C20.1404 21 20.9991 20.1414 20.9991 19.0822Z" fill="currentColor"/></svg>
		`,
		content: `
			<div class="uk-width-1-1 uk-box-shadow-small uk-sticky">
				<div class="uk-padding-remove">
					<div>
						<nav class="uk-navbar-container uk-height-auto uk-navbar" uk-navbar="mode: click">
							<div class="nav-overlay uk-navbar-left uk-width-expand">
								<ul class="uk-navbar-nav">
									<li>
										<a href="https://mylinkpreview.com/home">
											<span>MyLinkPreview</span>
										</a>
									</li>
									<li>
										<a href="https://mylinkpreview.com/#demo-preview" class="uk-text-capitalize">Demo</a>
									</li>
									<li>
										<a href="https://mylinkpreview.com/auth/register" class="uk-text-capitalize">Get API Key</a>
									</li>
									<li>
										<a href="https://mylinkpreview.com/documentation/api" class="uk-text-capitalize">Documentaion</a>
									</li>
									<li>
										<a href="https://mylinkpreview.com/#pricing-table" class="uk-text-capitalize">Pricing</a>
									</li>
								</ul>
							</div>
							<div class="nav-overlay uk-navbar-right">
								<ul class="uk-navbar-nav">
									<li class="uk-text-small">
										<a class="uk-text-capitalize" href="https://mylinkpreview.com/auth/login">My Dashboard <span uk-icon="icon: arrow-right; ratio: 0.72" class="uk-icon"></span></a>
									</li>
								</ul>
							</div>
						</nav>
					</div>
				</div>
			</div>
		`
	},
	{
		id: 'mapbox-with-pins',
		label: 'Mapbox Map',
		category: '🗺️ Maps & Location',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
				<circle cx="12" cy="10" r="3"/>
				<path d="m12 21.7-.39-.39A11.96 11.96 0 0 1 2 10.6C2 5.91 5.91 2 10.6 2s8.6 3.91 8.6 8.6a11.96 11.96 0 0 1-9.61 11.1z"/>
			</svg>
		`,
		content: {
			type: 'mapbox-with-pins',
			tagName: 'div',
			attributes: {
				'data-mapbox-component': 'MapboxWithPins',
				class: 'mapbox-component-wrapper'
			},
			script: `
				// Load Mapbox component
				import MapboxWithPins from './src/components/real-estate-blocks/maps/MapboxWithPins.jsx';
				// Component will be rendered here
			`,
			components: `
				<div class="mapbox-with-pins">
					<div class="mapbox-header">
						<h2 class="mapbox-title">Explore Properties on the Map</h2>
						<p class="mapbox-subtitle">Interactive map powered by Mapbox</p>
					</div>
					<div class="mapbox-container" style="height: 500px;">
						<div class="mapbox-placeholder">
							<div style="display: flex; align-items: center; justify-content: center; height: 100%; background: #f7fafc; border: 2px dashed #cbd5e0; border-radius: 8px; color: #4a5568; font-family: -apple-system, BlinkMacSystemFont, sans-serif;">
								<div style="text-align: center;">
									<svg style="width: 48px; height: 48px; margin: 0 auto 1rem auto; color: #cbd5e0;" fill="currentColor" viewBox="0 0 24 24">
										<circle cx="12" cy="10" r="3"/>
										<path d="m12 21.7-.39-.39A11.96 11.96 0 0 1 2 10.6C2 5.91 5.91 2 10.6 2s8.6 3.91 8.6 8.6a11.96 11.96 0 0 1-9.61 11.1z"/>
									</svg>
									<p style="margin: 0; font-size: 14px;">Mapbox Map with Property Pins</p>
									<p style="margin: 0.5rem 0 0 0; font-size: 12px; color: #718096;">Interactive map will load on published site</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'mapbox-search-filters',
		label: 'Mapbox Search',
		category: '🗺️ Maps & Location',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
				<circle cx="11" cy="11" r="8"/>
				<path d="m21 21-4.35-4.35"/>
				<circle cx="11" cy="8" r="2"/>
			</svg>
		`,
		content: {
			type: 'mapbox-search-filters',
			tagName: 'div',
			attributes: {
				'data-mapbox-component': 'MapboxSearchWithFilters',
				class: 'mapbox-search-component-wrapper'
			},
			script: `
				// Load Mapbox search component
				import MapboxSearchWithFilters from './src/components/real-estate-blocks/maps/MapboxSearchWithFilters.jsx';
				// Component will be rendered here
			`,
			components: `
				<div class="mapbox-search-with-filters">
					<div class="mapbox-search-header">
						<h2 class="mapbox-search-title">Property Map Search</h2>
						<p class="mapbox-search-subtitle">Find your perfect property with advanced search and filtering</p>
					</div>
					<div class="mapbox-filters-container">
						<div class="mapbox-filters-grid">
							<div class="mapbox-filter-group">
								<label class="mapbox-filter-label">Search Location</label>
								<input type="text" placeholder="Enter address, city, or neighborhood" class="mapbox-filter-input" />
							</div>
							<div class="mapbox-filter-group">
								<label class="mapbox-filter-label">Property Type</label>
								<select class="mapbox-filter-select">
									<option>All Types</option>
									<option>House</option>
									<option>Apartment</option>
									<option>Condo</option>
								</select>
							</div>
							<div class="mapbox-filter-group">
								<label class="mapbox-filter-label">Min Price</label>
								<input type="number" placeholder="Min $" class="mapbox-filter-input" />
							</div>
							<div class="mapbox-filter-group">
								<label class="mapbox-filter-label">Max Price</label>
								<input type="number" placeholder="Max $" class="mapbox-filter-input" />
							</div>
						</div>
					</div>
					<div class="mapbox-search-container" style="height: 600px;">
						<div class="mapbox-placeholder">
							<div style="display: flex; align-items: center; justify-content: center; height: 100%; background: #f7fafc; border: 2px dashed #cbd5e0; border-radius: 8px; color: #4a5568; font-family: -apple-system, BlinkMacSystemFont, sans-serif;">
								<div style="text-align: center;">
									<svg style="width: 48px; height: 48px; margin: 0 auto 1rem auto; color: #cbd5e0;" fill="currentColor" viewBox="0 0 24 24">
										<circle cx="11" cy="11" r="8"/>
										<path d="m21 21-4.35-4.35"/>
										<circle cx="11" cy="8" r="2"/>
									</svg>
									<p style="margin: 0; font-size: 14px;">Mapbox Search with Filters</p>
									<p style="margin: 0.5rem 0 0 0; font-size: 12px; color: #718096;">Interactive search map will load on published site</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'mapbox-with-draw',
		label: 'Mapbox Draw',
		category: '🗺️ Maps & Location',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
				<path d="M9 11H1v-1h8v1Z"/>
				<path d="M22 11h-8v-1h8v1Z"/>
				<path d="M14 19a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>
				<path d="M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0"/>
				<path d="M21 3l-3 3"/>
				<path d="M18 6l3-3"/>
			</svg>
		`,
		content: {
			type: 'mapbox-with-draw',
			tagName: 'div',
			attributes: {
				'data-mapbox-component': 'MapboxWithDraw',
				class: 'mapbox-draw-component-wrapper'
			},
			script: `
				// Load Mapbox draw component
				import MapboxWithDraw from './src/components/real-estate-blocks/maps/MapboxWithDraw.jsx';
				// Component will be rendered here
			`,
			components: `
				<div class="mapbox-with-draw">
					<div class="mapbox-header">
						<h2 class="mapbox-title">Interactive Drawing Map</h2>
						<p class="mapbox-subtitle">Draw shapes, lines, and points on the map</p>
					</div>
					<div class="mapbox-controls-bar">
						<div class="mapbox-draw-tools">
							<button class="mapbox-tool-button">📍 Point</button>
							<button class="mapbox-tool-button">📏 Line</button>
							<button class="mapbox-tool-button">⬟ Polygon</button>
							<button class="mapbox-tool-button">👆 Select</button>
						</div>
						<div class="mapbox-action-tools">
							<button class="mapbox-action-button">📊 Data (0)</button>
							<button class="mapbox-action-button">🗑️ Clear</button>
							<button class="mapbox-action-button">💾 Export</button>
							<button class="mapbox-action-button">📁 Import</button>
						</div>
					</div>
					<div class="mapbox-container" style="height: 500px;">
						<div class="mapbox-placeholder">
							<div style="display: flex; align-items: center; justify-content: center; height: 100%; background: #f7fafc; border: 2px dashed #cbd5e0; border-radius: 8px; color: #4a5568; font-family: -apple-system, BlinkMacSystemFont, sans-serif;">
								<div style="text-align: center;">
									<svg style="width: 48px; height: 48px; margin: 0 auto 1rem auto; color: #cbd5e0;" fill="currentColor" viewBox="0 0 24 24">
										<path d="M9 11H1v-1h8v1Z"/>
										<path d="M22 11h-8v-1h8v1Z"/>
										<path d="M14 19a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>
										<path d="M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0"/>
										<path d="M21 3l-3 3"/>
										<path d="M18 6l3-3"/>
									</svg>
									<p style="margin: 0; font-size: 14px;">Mapbox Drawing Map</p>
									<p style="margin: 0.5rem 0 0 0; font-size: 12px; color: #718096;">Interactive drawing map will load on published site</p>
								</div>
							</div>
						</div>
					</div>
					<div class="mapbox-footer">
						<div class="mapbox-instructions">
							<p><strong>Instructions:</strong></p>
							<ul>
								<li>Click the drawing tools to create points, lines, or polygons</li>
								<li>Use the Select tool to edit or delete features</li>
								<li>Export your drawings as GeoJSON or import existing files</li>
							</ul>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'linkpreview-middle-banner',
		label: 'Middle Banner',
		category: '🎭 Templates',
		media: `
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="text-gray-500"><path d="M20.9991 19.0822V4.91781C20.9991 3.85863 20.1404 3 19.0813 3H4.91781C3.85863 3 3 3.85863 3 4.91781V19.0822C3 20.1414 3.85863 21 4.91781 21H19.0813C20.1404 21 20.9991 20.1414 20.9991 19.0822Z" fill="currentColor"/></svg>
		`,
		content: `
			<div class="uk-width-1-1">
				<div class="uk-height-auto">
					<div>
						<div class="uk-width-xlarge uk-width-auto uk-padding-large uk-align-center uk-text-center">
							<h1>API for link previews</h1>
							<h5 class="uk-width-xlarge uk-align-center">Preview links with our REST API. We provide both raw JSON data, along with full embedding link preview capability.</h5>
							<div class="uk-margin">
								<a class="uk-button uk-button-default uk-visible" href="https://mylinkpreview.com/documentation/api">Documentation</a>
								<a class="uk-button uk-button-primary" href="https://mylinkpreview.com/auth/register">Get API Key</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		`
	},
	{
		id: 'linkpreview-col-1-2',
		label: 'Column 1-2',
		category: '🎭 Templates',
		media: `
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="text-gray-500"><path d="M20.9991 19.0822V4.91781C20.9991 3.85863 20.1404 3 19.0813 3H4.91781C3.85863 3 3 3.85863 3 4.91781V19.0822C3 20.1414 3.85863 21 4.91781 21H19.0813C20.1404 21 20.9991 20.1414 20.9991 19.0822Z" fill="currentColor"/></svg>
		`,
		content: `
			<div class="uk-height-auto uk-padding-large">
				<div class="uk-child-width-expand uk-flex uk-flex-middle uk-grid">
					<div class="uk-text-left uk-first-column">
						<h3 class="uk-margin-small-top">Request an API key</h3>
						<p>
							Simply click "Get API Key" to make requests to our api. To read more, see our <a href="https://mylinkpreview.com/documentation/api">Documentation</a> for use of the api key.
						</p>
					</div>
					<div>
						<div class="uk-card uk-card-default uk-scrollspy-inview uk-animation-fade" style="border: 1px solid rgb(229, 229, 229);">
							<div class="uk-container uk-padding-remove">
								<div>
									<nav class="uk-navbar-container uk-navbar" uk-navbar="">
										<div class="uk-navbar-left">
											<ul class="uk-navbar-nav">
												<li>
													<a>
														<span>MyLinkPreview</span>
													</a>
												</li>
												<li>
													<a class="uk-text-small" href="https://mylinkpreview.com/#">Demo</a>
												</li>
												<li class="uk-active">
													<a class="uk-text-small" href="https://mylinkpreview.com/auth/register">Get API Key</a>
												</li>
												<li>
													<a>
														<span uk-icon="more" class="uk-icon"></span>
													</a>
												</li>
											</ul>
										</div>
									</nav>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		`
	},
	{
		id: 'linkpreview-features',
		label: 'Features',
		category: '🎭 Templates',
		media: `
			<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="text-gray-500"><path d="M20.9991 19.0822V4.91781C20.9991 3.85863 20.1404 3 19.0813 3H4.91781C3.85863 3 3 3.85863 3 4.91781V19.0822C3 20.1414 3.85863 21 4.91781 21H19.0813C20.1404 21 20.9991 20.1414 20.9991 19.0822Z" fill="currentColor"/></svg>
		`,
		content: `
			<div class="uk-padding-large uk-box-shadow-small">
				<div class="uk-text-center uk-width-xlarge uk-align-center">
					<p>Major features we provide with our service.</p>
				</div>
				<div class="uk-grid-divider uk-padding-small uk-text-center uk-grid-small uk-grid-match uk-child-width-1-3 uk-grid">
					<div class="uk-first-column uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Image</h4>
						<span>Thumbnail image from the url</span>
					</div>
					<div class="uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Favicon</h4>
						<span>Website's favicon</span>
					</div>
					<div class="uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Embedding</h4>
						<span>Responsive link preview on your wesbsite</span>
					</div>
				</div>
				<hr>
				<div class="uk-grid-divider uk-padding-small uk-text-center uk-grid-small uk-grid-match uk-child-width-1-3 uk-grid" uk-grid="">
					<div class="uk-first-column uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Title</h4>
						<span>Obtain page title</span>
					</div>
					<div class="uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Description</h4>
						<span>Obtain page description</span>
					</div>
					<div class="uk-scrollspy-inview uk-animation-fade" style="">
						<h4 class="uk-margin-remove">Is Safe <span class="uk-label">Beta</span></h4>
						<span>URL risk checker</span>
					</div>
				</div>
			</div>
		`
	},
	{
		id: 'layout-page-0',
		label: 'Home 0',
		category: '🎭 Templates',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
				width="42" height="57"
				viewBox="0 0 172 172"
				style=" fill:#000000;" class="text-gray-500"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#b6c6d8"><path d="M24.08,6.88v158.24h123.84v-114.9175l-0.9675,-1.075l-41.28,-41.28l-1.075,-0.9675zM30.96,13.76h68.8v27.52h-48.16v6.88h48.16v6.88h41.28v103.2h-110.08zM106.64,18.705l29.455,29.455h-29.455zM51.6,75.68v6.88h10.32v-6.88zM75.68,75.68v6.88h44.72v-6.88zM51.6,96.32v6.88h10.32v-6.88zM75.68,96.32v6.88h44.72v-6.88zM51.6,116.96v6.88h10.32v-6.88zM75.68,116.96v6.88h44.72v-6.88z"></path></g></g></svg>
		`,
		content: `
			<div class="uk-section uk-section-default uk-padding-small uk-position-relative">
				<div class="uk-container uk-margin-small uk-padding-medium uk-container-large">
				<div id="ilqj" class="uk-box-shadow-small uk-border-rounded">
					<div class="uk-grid uk-margin-remove">
						<div id="im06m" class="uk-width-1-3 uk-flex uk-flex-middle uk-padding-medium">
							<div class="uk-padding-small uk-text-left uk-width-medium">
							<h1 class="uk-heading-small uk-width-1-1 uk-text-bold">Recipe
								<br/>Contest
							</h1>
							<p class="uk-text-small uk-width-1-1">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
							</p>
							<div id="i101" class="uk-width-1-1">
								<a href="#" id="ihbt" class="uk-display-inline">How they work</a>
								<div id="ik43h" class="uk-display-inline">
								</div>
							</div>
							</div>
						</div>
						<div class="uk-width-expand uk-padding-small uk-height-large">
							<div class="uk-height-1-1 uk-placeholder uk-flex uk-flex-middle uk-flex-center">[Remove and insert an image]
							</div>
						</div>
					</div>
					
				</div>
				<div id="iwwqm" class="uk-margin-medium-top">
					<div class="uk-grid uk-margin-remove">
						<ul class="uk-nav uk-nav-default uk-width-1-5 uk-padding-small">
							<li class="uk-active">
								<a href="#" id="imyez" class="uk-text-bold uk-text-large">Filter By</a>
							</li>
							<li>
								<a href="#" id="ir8xk">Contest Winners</a>
							</li>
							<li id="ihacp">
								<a href="#" id="i59ca">Featured</a>
							</li>
							<li id="imz84">
								<a href="#" id="ik4bt">Test Kitchen-Approved</a>
							</li>
						</ul>
						<div class="uk-width-expand">
							<div class="uk-text-center uk-grid">
								<div id="itdh" class="uk-width-1-3 uk-padding-small">
									<div id="idp1f" class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div id="i8wvs">
										<h1 id="ilthm" class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
										</p>
									</div>
									<div id="ihon8" class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
								<div class="uk-width-1-3 uk-padding-small">
									<div id="ibqq7" class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div id="iqy5m">
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
								<div id="ipjr" class="uk-width-1-3 uk-padding-small">
									<div id="i59ih" class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div id="i7bxa">
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<hr/>
				<div class="uk-margin-small-remove">
					<div id="isuyk" class="uk-padding-small">
						<h1 class="uk-text-bold uk-text-large uk-margin-remove">Featured
						</h1>
						<p class="uk-margin-remove">Some of our qualified listings.
						</p>
					</div>
					<div class="uk-grid uk-margin-remove">
						<div class="uk-width-expand">
							<div class="uk-text-center uk-grid">
								<div class="uk-padding-small uk-width-1-2">
									<div class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div>
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim inLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim inLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
								<div class="uk-padding-small uk-width-1-2">
									<div class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div>
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim inLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim inLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="uk-grid uk-margin-remove" id="i49l79">
					<div class="uk-padding-large uk-width-1-2">
						<div class="uk-flex uk-flex-middle uk-padding-medium uk-width-1-1 uk-flex-center">
							<div class="uk-padding-small uk-text-left uk-text-center">
							<h1 class="uk-heading-small uk-width-1-1 uk-text-bold">Recipes
							</h1>
							<p class="uk-text-small uk-width-medium uk-align-center uk-clearfix">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
							</p>
							<div class="uk-width-1-1">
								<a href="#" class="uk-display-inline">Show More Recipes</a>
								<div class="uk-display-inline">
								</div>
							</div>
							</div>
						</div>
					</div>
					<div class="uk-padding-large uk-width-1-2">
						<div class="uk-flex uk-flex-middle uk-padding-medium uk-width-1-1 uk-flex-center">
							<div class="uk-padding-small uk-text-left uk-text-center">
							<h1 class="uk-heading-small uk-width-1-1 uk-text-bold">Books
							</h1>
							<p class="uk-text-small uk-width-medium uk-align-center uk-clearfix">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
							</p>
							<div class="uk-width-1-1">
								<a href="#" class="uk-display-inline">Show More Books</a>
								<div class="uk-display-inline">
								</div>
							</div>
							</div>
						</div>
					</div>
					
				</div>
				<hr/>
				<div class="uk-margin-small-remove">
					<div id="iqljz" class="uk-padding-small">
						<h1 id="i53ze" class="uk-text-bold uk-text-large uk-margin-remove">Restaurants Near You
						</h1>
						<p id="iyp9dj" class="uk-margin-remove">Very delicios places around your neighbourhood.
						</p>
					</div>
					<div class="uk-grid uk-margin-remove">
						<div class="uk-width-expand">
							<div class="uk-text-center uk-grid">
								<div class="uk-width-1-3 uk-padding-small">
									<div class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div>
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
								<div class="uk-width-1-3 uk-padding-small">
									<div class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div>
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
								<div class="uk-width-1-3 uk-padding-small">
									<div class="uk-height-small uk-border-rounded uk-box-shadow-medium uk-margin-small">
									</div>
									<div>
										<h1 class="uk-text-left uk-margin-remove uk-text-small uk-text-bold">Kerala Chicken Curry
										</h1>
										<p class="uk-text-small uk-text-left uk-margin-remove">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros
										</p>
									</div>
									<div class="uk-width-1-1 uk-clearfix uk-margin-small-remove">
										<a href="#" class="uk-margin-remove uk-align-left uk-text-small">By Sarah Elvis</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="uk-container uk-margin-small uk-padding-medium uk-container-large uk-margin-small-remove">
					<div id="ilqj-2" class="uk-box-shadow-small uk-border-rounded uk-padding-large">
						<div id="im06m-2" class="uk-flex uk-flex-middle uk-padding-medium uk-width-1-1 uk-flex-center">
							<div class="uk-padding-small uk-text-left uk-text-center">
							<h1 class="uk-heading-small uk-width-1-1 uk-text-bold">Recipe Contest
							</h1>
							<p class="uk-text-small uk-width-medium uk-align-center uk-clearfix">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
							</p>
							<div id="i101-2" class="uk-width-1-1">
								<a href="#" id="ihbt-2" class="uk-display-inline">How they work</a>
								<div id="ik43h-2" class="uk-display-inline">
								</div>
							</div>
							</div>
						</div>
					</div>
					
				</div>
				
				</div>
			</div>
		`
	},
	{
		id: 'hero-with-video',
		label: '🎥 Hero Video',
		category: '🏠 Hero Sections',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
				<line x1="7" y1="2" x2="7" y2="22"/>
				<line x1="17" y1="2" x2="17" y2="22"/>
				<line x1="2" y1="12" x2="22" y2="12"/>
			</svg>
		`,
		content: {
			type: 'hero-with-video',
			script: `
				import { HeroWithVideo } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div class="hero-with-video" style="position: relative; min-height: 600px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; overflow: hidden;">
					<div style="position: relative; z-index: 2; text-align: center; padding: 2rem;">
						<h1 style="font-size: 3rem; font-weight: 700; margin: 0 0 1rem 0;">Find Your Dream Home</h1>
						<p style="font-size: 1.5rem; margin: 0 0 2rem 0; opacity: 0.9;">Discover luxury properties in prime locations</p>
						<div style="background: white; border-radius: 50px; padding: 0.5rem 1.5rem; display: inline-flex; align-items: center; gap: 1rem; max-width: 600px;">
							<input type="text" placeholder="Enter location, city, or ZIP code" style="border: none; outline: none; flex: 1; padding: 0.75rem; font-size: 1rem;" />
							<button style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; padding: 1rem 2rem; border-radius: 50px; font-weight: 600; cursor: pointer;">Search</button>
						</div>
						<div style="display: flex; justify-content: center; gap: 3rem; margin-top: 3rem;">
							<div><div style="font-size: 2rem; font-weight: 700;">10,000+</div><div style="font-size: 0.875rem; opacity: 0.9;">Properties</div></div>
							<div><div style="font-size: 2rem; font-weight: 700;">500+</div><div style="font-size: 0.875rem; opacity: 0.9;">Agents</div></div>
							<div><div style="font-size: 2rem; font-weight: 700;">50+</div><div style="font-size: 0.875rem; opacity: 0.9;">Cities</div></div>
						</div>
					</div>
					<div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.3); z-index: 1;"></div>
				</div>
			`
		}
	},
	{
		id: 'hero-split-screen',
		label: '⚡ Hero Split',
		category: '🏠 Hero Sections',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
				<line x1="12" y1="3" x2="12" y2="21"/>
			</svg>
		`,
		content: {
			type: 'hero-split-screen',
			script: `
				import { HeroSplitScreen } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div class="hero-split-screen" style="display: grid; grid-template-columns: 1fr 1fr; min-height: 600px;">
					<div style="background: url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=1200&fit=crop') center/cover; position: relative;">
						<div style="position: absolute; inset: 0; background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.2) 100%);"></div>
					</div>
					<div style="padding: 4rem; display: flex; align-items: center; background: white;">
						<div>
							<div style="display: inline-flex; align-items: center; gap: 0.5rem; background: #f0f4ff; color: #667eea; padding: 0.5rem 1rem; border-radius: 50px; font-size: 0.875rem; font-weight: 600; margin-bottom: 2rem;">
								<span style="width: 8px; height: 8px; background: #667eea; border-radius: 50%;"></span>
								New Properties Daily
							</div>
							<h1 style="font-size: 3rem; font-weight: 700; margin: 0 0 1.5rem 0; color: #1a1a1a;">Your Dream Home Awaits</h1>
							<p style="font-size: 1.25rem; color: #666; margin: 0 0 2rem 0;">Explore exclusive properties in the most sought-after neighborhoods</p>
							<div style="display: flex; gap: 1rem; margin-bottom: 2rem;">
								<input type="email" placeholder="Enter your email" style="flex: 1; padding: 1rem 1.5rem; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem;" />
								<button style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; padding: 1rem 2rem; border-radius: 12px; font-weight: 600; cursor: pointer;">Start Your Search →</button>
							</div>
							<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
								<div style="display: flex; align-items: center; gap: 0.75rem;"><span style="font-size: 1.5rem;">🏠</span><span style="font-size: 0.9375rem; color: #4b5563;">10,000+ Premium Listings</span></div>
								<div style="display: flex; align-items: center; gap: 0.75rem;"><span style="font-size: 1.5rem;">⭐</span><span style="font-size: 0.9375rem; color: #4b5563;">Expert Real Estate Agents</span></div>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'hero-minimal',
		label: '✨ Hero Minimal',
		category: '🏠 Hero Sections',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<circle cx="12" cy="12" r="10"/>
				<line x1="12" y1="8" x2="12" y2="12"/>
				<line x1="12" y1="16" x2="12.01" y2="16"/>
			</svg>
		`,
		content: {
			type: 'hero-minimal',
			script: `
				import { HeroMinimal } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div class="hero-minimal" style="min-height: 600px; display: flex; align-items: center; justify-content: center; background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%); position: relative;">
					<div style="text-align: center; padding: 4rem 2rem; max-width: 1200px;">
						<div style="display: flex; align-items: center; justify-content: center; gap: 1rem; margin-bottom: 2rem;">
							<span style="width: 40px; height: 1px; background: #667eea;"></span>
							<span style="font-size: 0.875rem; font-weight: 600; text-transform: uppercase; letter-spacing: 2px; color: #667eea;">Premium Real Estate</span>
							<span style="width: 40px; height: 1px; background: #667eea;"></span>
						</div>
						<h1 style="font-size: 4rem; font-weight: 300; color: #1a1a1a; margin: 0 0 1rem 0; letter-spacing: -2px;">Exceptional Properties</h1>
						<h2 style="font-size: 4rem; font-weight: 700; color: #1a1a1a; margin: 0 0 2rem 0; letter-spacing: -2px;">For Exceptional People</h2>
						<p style="font-size: 1.25rem; color: #666; max-width: 600px; margin: 0 auto 3rem auto;">Discover curated luxury real estate in the world's most desirable locations</p>
						<div style="display: flex; gap: 1.5rem; justify-content: center; margin-bottom: 4rem;">
							<button style="position: relative; padding: 1rem 2.5rem; font-size: 1rem; font-weight: 600; border: none; cursor: pointer; background: transparent; color: #1a1a1a; border-bottom: 2px solid #667eea;">Explore Collection</button>
							<button style="padding: 1rem 2.5rem; font-size: 1rem; font-weight: 600; border: 1px solid #e5e7eb; border-radius: 50px; cursor: pointer; background: transparent; color: #666;">Schedule Consultation</button>
						</div>
						<div style="display: flex; justify-content: center; align-items: center; gap: 3rem; padding-top: 3rem; border-top: 1px solid #e5e7eb;">
							<div style="text-align: center;"><div style="font-size: 2.5rem; font-weight: 700; color: #1a1a1a;">$2.5B+</div><div style="font-size: 0.875rem; color: #666; text-transform: uppercase; letter-spacing: 1px;">Properties Sold</div></div>
							<div style="width: 1px; height: 60px; background: #e5e7eb;"></div>
							<div style="text-align: center;"><div style="font-size: 2.5rem; font-weight: 700; color: #1a1a1a;">15+</div><div style="font-size: 0.875rem; color: #666; text-transform: uppercase; letter-spacing: 1px;">Years Experience</div></div>
							<div style="width: 1px; height: 60px; background: #e5e7eb;"></div>
							<div style="text-align: center;"><div style="font-size: 2.5rem; font-weight: 700; color: #1a1a1a;">98%</div><div style="font-size: 0.875rem; color: #666; text-transform: uppercase; letter-spacing: 1px;">Client Satisfaction</div></div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'hero-with-stats',
		label: '📊 Hero Stats',
		category: '🏠 Hero Sections',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<line x1="18" y1="20" x2="18" y2="10"/>
				<line x1="12" y1="20" x2="12" y2="4"/>
				<line x1="6" y1="20" x2="6" y2="14"/>
			</svg>
		`,
		content: {
			type: 'hero-with-stats',
			script: `
				import { HeroWithStats } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div class="hero-with-stats" style="position: relative; min-height: 600px; display: flex; align-items: center; background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%), url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&h=1080&fit=crop') center/cover; color: white;">
					<div style="max-width: 1400px; width: 100%; margin: 0 auto; padding: 4rem 2rem; display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center;">
						<div>
							<h1 style="font-size: 3.5rem; font-weight: 700; margin: 0 0 1.5rem 0;">Leading Real Estate Excellence</h1>
							<p style="font-size: 1.5rem; margin: 0 0 2rem 0; opacity: 0.9;">Trusted by thousands of clients nationwide</p>
							<button style="display: inline-flex; align-items: center; gap: 0.75rem; background: white; color: #1a1a1a; border: none; padding: 1.25rem 2.5rem; border-radius: 12px; font-size: 1.125rem; font-weight: 600; cursor: pointer;">View Properties →</button>
						</div>
						<div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 2rem;">
							<div style="background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 16px; padding: 2rem;">
								<div style="font-size: 2.5rem; font-weight: 700; margin-bottom: 0.5rem;">2,500+</div>
								<div style="font-size: 0.9375rem; opacity: 0.8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 1rem;">Properties Sold</div>
								<div style="width: 100%; height: 4px; background: rgba(255, 255, 255, 0.2); border-radius: 2px; overflow: hidden;"><div style="width: 100%; height: 100%; background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);"></div></div>
							</div>
							<div style="background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 16px; padding: 2rem;">
								<div style="font-size: 2.5rem; font-weight: 700; margin-bottom: 0.5rem;">15</div>
								<div style="font-size: 0.9375rem; opacity: 0.8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 1rem;">Years Experience</div>
								<div style="width: 100%; height: 4px; background: rgba(255, 255, 255, 0.2); border-radius: 2px; overflow: hidden;"><div style="width: 100%; height: 100%; background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);"></div></div>
							</div>
							<div style="background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 16px; padding: 2rem;">
								<div style="font-size: 2.5rem; font-weight: 700; margin-bottom: 0.5rem;">98%</div>
								<div style="font-size: 0.9375rem; opacity: 0.8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 1rem;">Client Satisfaction</div>
								<div style="width: 100%; height: 4px; background: rgba(255, 255, 255, 0.2); border-radius: 2px; overflow: hidden;"><div style="width: 98%; height: 100%; background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);"></div></div>
							</div>
							<div style="background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 16px; padding: 2rem;">
								<div style="font-size: 2.5rem; font-weight: 700; margin-bottom: 0.5rem;">$2.5B</div>
								<div style="font-size: 0.9375rem; opacity: 0.8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 1rem;">Total Sales</div>
								<div style="width: 100%; height: 4px; background: rgba(255, 255, 255, 0.2); border-radius: 2px; overflow: hidden;"><div style="width: 100%; height: 100%; background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);"></div></div>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'hero-animated-gradient',
		label: '🌈 Hero Gradient',
		category: '🏠 Hero Sections',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<path d="M12 2L2 7l10 5 10-5-10-5z"/>
				<path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
			</svg>
		`,
		content: {
			type: 'hero-animated-gradient',
			script: `
				import { HeroAnimatedGradient } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div class="hero-animated-gradient" style="position: relative; min-height: 600px; display: flex; align-items: center; overflow: hidden; background: #0a0a0a; color: white;">
					<div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;">
						<div style="position: absolute; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(102, 126, 234, 0.4) 0%, transparent 70%); top: -200px; right: -100px; filter: blur(100px);"></div>
						<div style="position: absolute; width: 500px; height: 500px; border-radius: 50%; background: radial-gradient(circle, rgba(118, 75, 162, 0.4) 0%, transparent 70%); bottom: -150px; left: -100px; filter: blur(100px);"></div>
						<div style="position: absolute; width: 400px; height: 400px; border-radius: 50%; background: radial-gradient(circle, rgba(240, 147, 251, 0.3) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -50%); filter: blur(100px);"></div>
					</div>
					<div style="position: relative; z-index: 2; max-width: 1400px; width: 100%; margin: 0 auto; padding: 4rem 2rem; display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center;">
						<div>
							<div style="display: inline-flex; align-items: center; gap: 0.75rem; background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); padding: 0.75rem 1.5rem; border-radius: 50px; font-size: 0.875rem; font-weight: 600; margin-bottom: 2rem;">
								<span style="width: 8px; height: 8px; background: #10b981; border-radius: 50%;"></span>
								New Listings Available
							</div>
							<h1 style="font-size: 3.5rem; font-weight: 700; margin: 0 0 1.5rem 0; background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">Discover Your Perfect Property</h1>
							<p style="font-size: 1.25rem; opacity: 0.8; margin: 0 0 2rem 0;">Luxury homes in the most desirable locations</p>
							<div style="display: flex; gap: 1rem;">
								<button style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 1.125rem 2rem; border-radius: 12px; font-size: 1rem; font-weight: 600; cursor: pointer; border: none; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">Browse Properties →</button>
								<button style="padding: 1.125rem 2rem; border-radius: 12px; font-size: 1rem; font-weight: 600; cursor: pointer; background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.2); color: white;">Contact Agent</button>
							</div>
						</div>
						<div style="position: relative; height: 400px; border-radius: 24px; overflow: hidden; box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);">
							<img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop" style="width: 100%; height: 100%; object-fit: cover;" />
							<div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 2rem; background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);">
								<div style="font-size: 2rem; font-weight: 700; margin-bottom: 0.5rem;">$2,450,000</div>
								<div style="display: flex; align-items: center; gap: 0.5rem; opacity: 0.9;">📍 Beverly Hills, CA</div>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'hero-with-search',
		label: '🔍 Hero Search',
		category: '🏠 Hero Sections',
		media: `
			<svg width="28" height="28" viewBox="0 0 24 24" fill="none" style="display:block;margin:auto;color:#007AFF" xmlns="http://www.w3.org/2000/svg">
				<path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
			</svg>
		`,
		content: {
			type: 'hero-with-search',
			components: `
				<div style="position: relative; min-height: 600px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; color: white; padding: 2rem;">
					<div style="max-width: 800px; width: 100%; text-align: center;">
						<h1 style="font-size: 3.5rem; font-weight: 700; margin: 0 0 1.5rem 0;">Find Your Dream Home</h1>
						<p style="font-size: 1.25rem; opacity: 0.9; margin: 0 0 2.5rem 0;">Search through thousands of properties</p>
						<div style="background: white; border-radius: 12px; padding: 1rem; display: flex; gap: 1rem; box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);">
							<input type="text" placeholder="Enter location..." style="flex: 1; padding: 1rem; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 1rem;" />
							<select style="padding: 1rem; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 1rem; min-width: 150px;">
								<option>Property Type</option>
								<option>House</option>
								<option>Apartment</option>
								<option>Condo</option>
							</select>
							<button style="padding: 1rem 2.5rem; background: #667eea; color: white; border: none; border-radius: 8px; font-size: 1rem; font-weight: 600; cursor: pointer;">Search</button>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'property-grid',
		label: '📊 Property Grid',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="3" y="3" width="7" height="7"/>
				<rect x="14" y="3" width="7" height="7"/>
				<rect x="14" y="14" width="7" height="7"/>
				<rect x="3" y="14" width="7" height="7"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="grid" data-columns="3" data-limit="6"></div>
		`
	},
	{
		id: 'property-list',
		label: '📋 Property List',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<line x1="8" y1="6" x2="21" y2="6"/>
				<line x1="8" y1="12" x2="21" y2="12"/>
				<line x1="8" y1="18" x2="21" y2="18"/>
				<line x1="3" y1="6" x2="3.01" y2="6"/>
				<line x1="3" y1="12" x2="3.01" y2="12"/>
				<line x1="3" y1="18" x2="3.01" y2="18"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="grid" data-columns="1" data-limit="4"></div>
		`
	},
	{
		id: 'property-slider',
		label: '🎬 Property Slider',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
				<polyline points="17 2 12 7 7 2"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="slider" data-limit="6"></div>
		`
	},
	{
		id: 'property-masonry',
		label: '🧱 Property Masonry',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="3" y="3" width="7" height="9"/>
				<rect x="3" y="14" width="7" height="7"/>
				<rect x="14" y="3" width="7" height="5"/>
				<rect x="14" y="10" width="7" height="11"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="grid" data-columns="3" data-limit="6"></div>
		`
	},
	{
		id: 'property-compact',
		label: '📦 Property Compact',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<rect x="3" y="3" width="7" height="7"/>
				<rect x="3" y="13" width="7" height="7"/>
				<rect x="13" y="3" width="7" height="7"/>
				<rect x="13" y="13" width="7" height="7"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="grid" data-columns="4" data-limit="8"></div>
		`
	},
	{
		id: 'property-featured',
		label: '⭐ Property Featured',
		category: '🏘️ Property Listings',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
			</svg>
		`,
		content: `
			<div class="gdx-properties" data-type="featured" data-limit="5"></div>
		`
	},
	{
		id: 'filter-sidebar',
		label: '🔧 Filter Sidebar',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<line x1="4" y1="21" x2="4" y2="14"/>
				<line x1="4" y1="10" x2="4" y2="3"/>
				<line x1="12" y1="21" x2="12" y2="12"/>
				<line x1="12" y1="8" x2="12" y2="3"/>
				<line x1="20" y1="21" x2="20" y2="16"/>
				<line x1="20" y1="12" x2="20" y2="3"/>
				<line x1="1" y1="14" x2="7" y2="14"/>
				<line x1="9" y1="8" x2="15" y2="8"/>
				<line x1="17" y1="16" x2="23" y2="16"/>
			</svg>
		`,
		content: {
			type: 'filter-sidebar',
			script: `
				import { FilterSidebar } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="width: 320px; height: 600px; background: #ffffff; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column;">
					<div style="display: flex; justify-content: space-between; align-items: center; padding: 1.5rem; border-bottom: 1px solid #e5e7eb;">
						<h3 style="font-size: 1.5rem; font-weight: 700; color: #1a1a1a; margin: 0;">Filters</h3>
					</div>
					<div style="flex: 1; padding: 1.5rem; overflow-y: auto;">
						<div style="margin-bottom: 2rem;">
							<label style="display: block; font-size: 0.9375rem; font-weight: 600; color: #1a1a1a; margin-bottom: 1rem;">Price Range</label>
							<div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
								<input type="text" placeholder="Min" style="flex: 1; padding: 0.75rem; border: 1px solid #e5e7eb; border-radius: 8px;" value="$0" />
								<span style="color: #666;">to</span>
								<input type="text" placeholder="Max" style="flex: 1; padding: 0.75rem; border: 1px solid #e5e7eb; border-radius: 8px;" value="$5M" />
							</div>
						</div>
						<div style="margin-bottom: 2rem;">
							<label style="display: block; font-size: 0.9375rem; font-weight: 600; color: #1a1a1a; margin-bottom: 1rem;">Bedrooms</label>
							<div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.5rem;">
								<button style="padding: 0.75rem; border: 1px solid #e5e7eb; border-radius: 8px; background: #ffffff; font-weight: 500; color: #666;">any</button>
								<button style="padding: 0.75rem; border: 1px solid #e5e7eb; border-radius: 8px; background: #ffffff; font-weight: 500; color: #666;">1+</button>
								<button style="padding: 0.75rem; border: 1px solid #e5e7eb; border-radius: 8px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-weight: 500;">2+</button>
							</div>
						</div>
					</div>
					<div style="padding: 1.5rem; border-top: 1px solid #e5e7eb; display: flex; gap: 1rem;">
						<button style="flex: 1; padding: 1rem; border-radius: 8px; background: #f7fafc; border: 1px solid #e5e7eb; color: #666; font-weight: 600;">Clear All</button>
						<button style="flex: 1; padding: 1rem; border-radius: 8px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border: none; color: white; font-weight: 600;">Apply</button>
					</div>
				</div>
			`
		}
	},
	{
		id: 'filter-topbar',
		label: '🔝 Filter Top Bar',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<line x1="3" y1="12" x2="21" y2="12"/>
				<line x1="3" y1="6" x2="21" y2="6"/>
				<line x1="3" y1="18" x2="21" y2="18"/>
			</svg>
		`,
		content: {
			type: 'filter-topbar',
			script: `
				import { FilterTopBar } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="background: #ffffff; border-bottom: 1px solid #e5e7eb; padding: 1.5rem 2rem; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);">
					<div style="max-width: 1400px; margin: 0 auto; display: flex; gap: 1rem; align-items: center;">
						<div style="flex: 1; position: relative;">
							<input type="text" placeholder="Search by location, city, or ZIP code" style="width: 100%; padding: 1rem 1rem 1rem 3rem; border: 1px solid #e5e7eb; border-radius: 12px; font-size: 1rem;" />
						</div>
						<select style="padding: 1rem 1.5rem; border: 1px solid #e5e7eb; border-radius: 12px; background: #ffffff; min-width: 150px;">
							<option>Any Price</option>
							<option>$0 - $500K</option>
							<option>$500K - $1M</option>
						</select>
						<select style="padding: 1rem 1.5rem; border: 1px solid #e5e7eb; border-radius: 12px; background: #ffffff; min-width: 150px;">
							<option>Any Beds</option>
							<option>1+ Beds</option>
							<option>2+ Beds</option>
						</select>
						<button style="padding: 1rem 2.5rem; border: none; border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-weight: 600;">Search</button>
					</div>
				</div>
			`
		}
	},
	{
		id: 'quick-filters',
		label: '💊 Quick Filters',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<circle cx="12" cy="12" r="10"/>
				<circle cx="12" cy="12" r="6"/>
				<circle cx="12" cy="12" r="2"/>
			</svg>
		`,
		content: {
			type: 'quick-filters',
			script: `
				import { QuickFilters } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="background: #ffffff; border-bottom: 1px solid #e5e7eb; padding: 1.5rem 2rem;">
					<div style="max-width: 1400px; margin: 0 auto; display: flex; align-items: center; gap: 1.5rem;">
						<div style="font-size: 0.9375rem; font-weight: 600; color: #1a1a1a;">Quick Filters:</div>
						<div style="display: flex; gap: 0.75rem; flex-wrap: wrap; flex: 1;">
							<button style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.625rem 1.25rem; border: 1px solid #e5e7eb; border-radius: 50px; background: #ffffff; font-size: 0.875rem; font-weight: 500; color: #666;">
								<span>🏊</span> Pool
							</button>
							<button style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.625rem 1.25rem; border: none; border-radius: 50px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); font-size: 0.875rem; font-weight: 500; color: white;">
								<span>🚗</span> Garage
							</button>
							<button style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.625rem 1.25rem; border: 1px solid #e5e7eb; border-radius: 50px; background: #ffffff; font-size: 0.875rem; font-weight: 500; color: #666;">
								<span>🌳</span> Garden
							</button>
							<button style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.625rem 1.25rem; border: 1px solid #e5e7eb; border-radius: 50px; background: #ffffff; font-size: 0.875rem; font-weight: 500; color: #666;">
								<span>💎</span> Luxury
							</button>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'advanced-search',
		label: '🧙 Advanced Search',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<circle cx="11" cy="11" r="8"/>
				<path d="m21 21-4.35-4.35"/>
				<line x1="11" y1="8" x2="11" y2="14"/>
				<line x1="8" y1="11" x2="14" y2="11"/>
			</svg>
		`,
		content: {
			type: 'advanced-search',
			script: `
				import { AdvancedSearch } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="padding: 4rem 2rem; background: linear-gradient(to bottom, #f7fafc 0%, #ffffff 100%); min-height: 600px;">
					<div style="max-width: 900px; margin: 0 auto; background: #ffffff; border-radius: 24px; padding: 3rem; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);">
						<div style="text-align: center; margin-bottom: 3rem;">
							<h2 style="font-size: 2.5rem; font-weight: 700; color: #1a1a1a; margin: 0 0 0.5rem 0;">Find Your Perfect Property</h2>
							<p style="font-size: 1.125rem; color: #666; margin: 0;">Answer a few questions to get personalized results</p>
						</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 3rem; position: relative;">
							<div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem;">
								<div style="width: 48px; height: 48px; border-radius: 50%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; color: white; font-size: 1.25rem; font-weight: 600;">📍</div>
								<div style="font-size: 0.875rem; font-weight: 600; color: #1a1a1a;">Location</div>
							</div>
							<div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem;">
								<div style="width: 48px; height: 48px; border-radius: 50%; background: #f7fafc; border: 2px solid #e5e7eb; display: flex; align-items: center; justify-content: center; font-size: 1.25rem;">🏠</div>
								<div style="font-size: 0.875rem; color: #666;">Property Type</div>
							</div>
							<div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem;">
								<div style="width: 48px; height: 48px; border-radius: 50%; background: #f7fafc; border: 2px solid #e5e7eb; display: flex; align-items: center; justify-content: center; font-size: 1.25rem;">💰</div>
								<div style="font-size: 0.875rem; color: #666;">Budget</div>
							</div>
							<div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem;">
								<div style="width: 48px; height: 48px; border-radius: 50%; background: #f7fafc; border: 2px solid #e5e7eb; display: flex; align-items: center; justify-content: center; font-size: 1.25rem;">⚙️</div>
								<div style="font-size: 0.875rem; color: #666;">Details</div>
							</div>
						</div>
						<div style="min-height: 200px; margin-bottom: 2rem;">
							<h3 style="font-size: 1.75rem; font-weight: 700; color: #1a1a1a; margin: 0 0 2rem 0; text-align: center;">Where are you looking?</h3>
							<input type="text" placeholder="Enter city, neighborhood, or ZIP code" style="width: 100%; padding: 1.25rem 1.5rem; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.125rem;" />
						</div>
						<div style="display: flex; gap: 1rem; padding-top: 2rem; border-top: 1px solid #e5e7eb;">
							<div style="flex: 1;"></div>
							<button style="padding: 1.125rem 2.5rem; border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border: none; color: white; font-size: 1rem; font-weight: 600;">Next →</button>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'saved-searches',
		label: '💾 Saved Searches',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
			</svg>
		`,
		content: {
			type: 'saved-searches',
			script: `
				import { SavedSearches } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="padding: 4rem 2rem; background: #f7fafc;">
					<div style="max-width: 1200px; margin: 0 auto;">
						<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem;">
							<h2 style="font-size: 2rem; font-weight: 700; color: #1a1a1a; margin: 0;">Saved Searches</h2>
							<button style="padding: 1rem 2rem; border: none; border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-weight: 600;">+ New Search</button>
						</div>
						<div style="background: #ffffff; border-radius: 16px; padding: 2rem; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);">
							<div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 2rem; margin-bottom: 1.5rem;">
								<div style="flex: 1;">
									<h3 style="font-size: 1.5rem; font-weight: 700; color: #1a1a1a; margin: 0 0 1rem 0;">Beverly Hills Homes</h3>
									<div style="display: flex; gap: 1.5rem; margin-bottom: 1rem; flex-wrap: wrap;">
										<span style="font-size: 0.9375rem; color: #666;">📍 Beverly Hills, CA</span>
										<span style="font-size: 0.9375rem; color: #666;">💰 $1M - $3M</span>
										<span style="font-size: 0.9375rem; color: #666;">🛏️ 4+</span>
									</div>
									<div style="display: flex; gap: 1.5rem; font-size: 0.875rem;">
										<span style="color: #667eea; font-weight: 600;">23 new results</span>
										<span style="color: #999;">Last checked 2 hours ago</span>
									</div>
								</div>
								<button style="padding: 0.875rem 1.5rem; border: none; border-radius: 8px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-weight: 600;">View Results</button>
							</div>
							<div style="padding: 1rem 1.5rem; background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%); border-left: 4px solid #667eea; border-radius: 8px; color: #667eea; font-weight: 600;">
								23 new properties match your criteria
							</div>
						</div>
					</div>
				</div>
			`
		}
	},
	{
		id: 'search-suggestions',
		label: '🔍 Search Suggestions',
		category: '🔍 Search & Filters',
		media: `
			<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
				<circle cx="11" cy="11" r="8"/>
				<path d="m21 21-4.35-4.35"/>
				<path d="M11 8a3 3 0 0 0-3 3"/>
			</svg>
		`,
		content: {
			type: 'search-suggestions',
			script: `
				import { SearchSuggestions } from './src/components/real-estate-blocks/index.js';
			`,
			components: `
				<div style="padding: 4rem 2rem; background: #ffffff;">
					<div style="max-width: 800px; margin: 0 auto; position: relative;">
						<div style="position: relative;">
							<input type="text" placeholder="Search by location, property type, or features..." style="width: 100%; padding: 1.5rem 4rem 1.5rem 4rem; border: 2px solid #e5e7eb; border-radius: 16px; font-size: 1.125rem; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);" />
						</div>
						<div style="position: absolute; top: calc(100% + 0.5rem); left: 0; right: 0; background: #ffffff; border: 1px solid #e5e7eb; border-radius: 16px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12); max-height: 400px; overflow-y: auto;">
							<div style="padding: 1rem 0; border-bottom: 1px solid #e5e7eb;">
								<div style="padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 600; color: #999; text-transform: uppercase;">Recent Searches</div>
								<button style="width: 100%; display: flex; align-items: center; gap: 1rem; padding: 1rem 1.5rem; border: none; background: none; text-align: left; cursor: pointer;">
									<span style="font-size: 1rem; color: #1a1a1a;">3 bedroom houses in Beverly Hills</span>
								</button>
								<button style="width: 100%; display: flex; align-items: center; gap: 1rem; padding: 1rem 1.5rem; border: none; background: none; text-align: left; cursor: pointer;">
									<span style="font-size: 1rem; color: #1a1a1a;">Apartments under $1M in Los Angeles</span>
								</button>
							</div>
							<div style="padding: 1rem 0;">
								<div style="padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 600; color: #999; text-transform: uppercase;">Popular Searches</div>
								<button style="width: 100%; display: flex; align-items: center; gap: 1rem; padding: 1rem 1.5rem; border: none; background: none; text-align: left; cursor: pointer;">
									<span style="font-size: 1rem; color: #1a1a1a;">Luxury homes Los Angeles</span>
								</button>
								<button style="width: 100%; display: flex; align-items: center; gap: 1rem; padding: 1rem 1.5rem; border: none; background: none; text-align: left; cursor: pointer;">
									<span style="font-size: 1rem; color: #1a1a1a;">Condos Santa Monica</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			`
		}
	},

  // ─── Table Blocks ──────────────────────────────────────────────────────────
  {
    id: 'data-table',
    label: 'Data Table',
    category: '📊 Tables',
    media: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 4v2h14V8H5zm0 4v2h14v-2H5zm0 4v2h14v-2H5zm0-10v2h14V6H5z"/></svg>`,
    content: `
      <table style="width:100%;border-collapse:collapse;font-family:inherit;">
        <thead>
          <tr style="background:#f3f4f6;">
            <th style="padding:12px 16px;text-align:left;font-weight:600;font-size:14px;color:#374151;border-bottom:2px solid #e5e7eb;">Column A</th>
            <th style="padding:12px 16px;text-align:left;font-weight:600;font-size:14px;color:#374151;border-bottom:2px solid #e5e7eb;">Column B</th>
            <th style="padding:12px 16px;text-align:left;font-weight:600;font-size:14px;color:#374151;border-bottom:2px solid #e5e7eb;">Column C</th>
          </tr>
        </thead>
        <tbody>
          <tr style="border-bottom:1px solid #e5e7eb;">
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 1, Cell 1</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 1, Cell 2</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 1, Cell 3</td>
          </tr>
          <tr style="border-bottom:1px solid #e5e7eb;background:#fafafa;">
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 2, Cell 1</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 2, Cell 2</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 2, Cell 3</td>
          </tr>
          <tr style="border-bottom:1px solid #e5e7eb;">
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 3, Cell 1</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 3, Cell 2</td>
            <td style="padding:12px 16px;font-size:14px;color:#374151;">Row 3, Cell 3</td>
          </tr>
        </tbody>
      </table>
    `
  },
  {
    id: 'property-specs-table',
    label: 'Property Specs Table',
    category: '📊 Tables',
    media: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>`,
    content: `
      <div style="font-family:inherit;border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;">
        <div style="padding:16px 20px;background:#1a1a2e;color:#fff;">
          <h3 style="margin:0;font-size:18px;font-weight:600;">Property Details</h3>
        </div>
        <table style="width:100%;border-collapse:collapse;">
          <tbody>
            <tr style="border-bottom:1px solid #e5e7eb;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;width:40%;">Bedrooms</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">4</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;background:#fafafa;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Bathrooms</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">3</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Square Footage</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">2,450 sq ft</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;background:#fafafa;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Lot Size</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">0.35 acres</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Year Built</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">2018</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;background:#fafafa;">
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Garage</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">2-car attached</td>
            </tr>
            <tr>
              <td style="padding:12px 20px;font-size:14px;font-weight:600;color:#6b7280;">Price</td>
              <td style="padding:12px 20px;font-size:16px;font-weight:700;color:#1a1a2e;">$875,000</td>
            </tr>
          </tbody>
        </table>
      </div>
    `
  },
  {
    id: 'open-house-schedule',
    label: 'Open House Schedule',
    category: '📊 Tables',
    media: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/></svg>`,
    content: `
      <div style="font-family:inherit;border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;">
        <div style="padding:16px 20px;background:#059669;color:#fff;">
          <h3 style="margin:0;font-size:18px;font-weight:600;">Open House Schedule</h3>
        </div>
        <table style="width:100%;border-collapse:collapse;">
          <thead>
            <tr style="background:#f3f4f6;">
              <th style="padding:12px 20px;text-align:left;font-weight:600;font-size:13px;color:#374151;border-bottom:1px solid #e5e7eb;">Date</th>
              <th style="padding:12px 20px;text-align:left;font-weight:600;font-size:13px;color:#374151;border-bottom:1px solid #e5e7eb;">Day</th>
              <th style="padding:12px 20px;text-align:left;font-weight:600;font-size:13px;color:#374151;border-bottom:1px solid #e5e7eb;">Time</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom:1px solid #e5e7eb;">
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">January 18, 2025</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">Saturday</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">1:00 PM – 4:00 PM</td>
            </tr>
            <tr style="border-bottom:1px solid #e5e7eb;background:#fafafa;">
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">January 19, 2025</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">Sunday</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">2:00 PM – 5:00 PM</td>
            </tr>
            <tr>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">January 25, 2025</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">Saturday</td>
              <td style="padding:12px 20px;font-size:14px;color:#1f2937;">1:00 PM – 3:00 PM</td>
            </tr>
          </tbody>
        </table>
        <div style="padding:12px 20px;background:#f0fdf4;border-top:1px solid #e5e7eb;font-size:13px;color:#059669;">
          No appointment needed — walk-ins welcome!
        </div>
      </div>
    `
  },

  // ─── Photo Gallery / Slider Block ──────────────────────────────────────────
  {
    id: 'property-photo-gallery',
    label: 'Property Photo Gallery',
    category: '🖼️ Media',
    media: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"/></svg>`,
    content: `
      <div class="photo-gallery" style="position:relative;width:100%;overflow:hidden;border-radius:8px;background:#000;">
        <div class="gallery-track" style="display:flex;transition:transform 0.4s ease;will-change:transform;">
          <div class="gallery-slide" style="min-width:100%;position:relative;">
            <img src="https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1200&q=80" alt="Property exterior" style="width:100%;height:480px;object-fit:cover;display:block;" />
            <div style="position:absolute;bottom:16px;right:16px;background:rgba(0,0,0,0.6);color:#fff;padding:4px 10px;border-radius:4px;font-size:13px;">1 / 4</div>
          </div>
          <div class="gallery-slide" style="min-width:100%;">
            <img src="https://images.unsplash.com/photo-1556912167-f556f1f39fdf?w=1200&q=80" alt="Living room" style="width:100%;height:480px;object-fit:cover;display:block;" />
          </div>
          <div class="gallery-slide" style="min-width:100%;">
            <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80" alt="Kitchen" style="width:100%;height:480px;object-fit:cover;display:block;" />
          </div>
          <div class="gallery-slide" style="min-width:100%;">
            <img src="https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=1200&q=80" alt="Master bedroom" style="width:100%;height:480px;object-fit:cover;display:block;" />
          </div>
        </div>
        <button onclick="(function(btn){var t=btn.closest('.photo-gallery').querySelector('.gallery-track');var slides=t.querySelectorAll('.gallery-slide');var cur=parseInt(t.dataset.current||0);cur=cur===0?slides.length-1:cur-1;t.style.transform='translateX(-'+cur*100+'%)';t.dataset.current=cur;var counter=btn.closest('.photo-gallery').querySelector('.gallery-slide:first-child div');if(counter)counter.textContent=(cur+1)+' / '+slides.length;})(this)"
          style="position:absolute;left:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.85);border:none;border-radius:50%;width:40px;height:40px;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;">&#8249;</button>
        <button onclick="(function(btn){var t=btn.closest('.photo-gallery').querySelector('.gallery-track');var slides=t.querySelectorAll('.gallery-slide');var cur=parseInt(t.dataset.current||0);cur=cur===slides.length-1?0:cur+1;t.style.transform='translateX(-'+cur*100+'%)';t.dataset.current=cur;var counter=btn.closest('.photo-gallery').querySelector('.gallery-slide:first-child div');if(counter)counter.textContent=(cur+1)+' / '+slides.length;})(this)"
          style="position:absolute;right:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.85);border:none;border-radius:50%;width:40px;height:40px;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;">&#8250;</button>
        <div style="display:flex;justify-content:center;gap:6px;padding:12px 0;background:rgba(0,0,0,0.6);">
          <span style="width:8px;height:8px;border-radius:50%;background:#fff;display:inline-block;"></span>
          <span style="width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.4);display:inline-block;"></span>
          <span style="width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.4);display:inline-block;"></span>
          <span style="width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.4);display:inline-block;"></span>
        </div>
      </div>
    `
  },
];